<template>
  <div class="page-instructions-eligibility page-instructions">
    <div class="banner-wrap">
      <h1 class="banner-title bold">申请资格</h1>
    </div>
    <div class="page-content">
      <template v-if="$store.state.isAMCSite">
        <h2 class="h2 color-gray-1">2026年哈佛HSYLC峰会现招募“少年挚愿者”</h2>
        <p class="text1 color-gray-2 mt-30">
          峰会招募优秀高中生以“少年挚愿者”身份积极参与和服务峰会的公益行动，该学生通过峰会前期在组委会带领下参与服务峰会中偏远和贫困地区学生适应峰会预习材料等帮扶工作，为国际青年交流盛会贡献力量，进一步展现学生的社会责任和公益行为。该“少年挚愿者”需经过严格选拔，选拔标准包括学术能力、参与文化交流的主动性以及参与公益服务的意愿等。
        </p>
        <p class="text1 color-gray-2 mt-10">为成为哈佛HSYLC峰会的“少年挚愿者”，申请者必须满足以下所有条件：</p>
      </template>
      <p class="text1 color-gray-2" v-else>为参与HSYLC，申请者必须满足以下<span class="sybold">所有条件</span>:</p>
      <h2 class="h2 color-gray-1 mt-30">年级</h2>
      <p class="text1 color-gray-2 mt-10">
        现就读初三至高三同学，因此作为申请者，截至2026年9月，你必须已经完成初中学业，且还未开始就读大学。<br />
        若你正处于高中毕业后的间隔年(Gap Year），还未开始大学学业，可作为学生申请HSYLC。
      </p>
      <h2 class="h2 color-gray-1 mt-30">国籍</h2>
      <p class="text1 color-gray-2 mt-10">国籍不限，无论在中国高中还是海外高中就读的学生都可以参加。</p>
      <h2 class="h2 color-gray-1 mt-30">语言水平</h2>
      <ul class="ul text1 color-gray-2 mt-10">
        <li>由于在课堂上需要用英语与师生互动讨论，HSYLC要求所有学生具备良好的中英文阅读、沟通和书写能力。</li>
        <li>
          托福或雅思等标准化考试成绩在申请中不是必须的，没有相关考试成绩的同学将不会影响被录取几率，可通过申请表中的在校成绩、英文文书等体现自己的语言能力。
        </li>
      </ul>
      <template v-if="!$store.state.isAMCSite">
        <h2 class="wrap-title sybold">学生实习生（Student Intern）</h2>
        <p class="text1 color-gray-2 mt-10">
          欢迎加入每年数百位再次回归峰会的学生行列！每年的内容、学者、和校友都不同，在这里你将获得新的惊喜和成长，同时我们也非常鼓励往年学生申请峰会现场的进阶角色——学生实习生(Student
          Intern,
          初三到高三学生皆可申请)，经选拔录取后，可加入幕后策划和执行工作，承担更多责任，获得更大历练，进一步强化自己的领导能力和团队协作能力，获得实习证明。
        </p>
        <!-- <p class="text1 bold color-red-default mt-10 pointer underline" @click="$windowOpen('/join-us/si')">点击了解峰会学生实习生</p> -->
        <p class="text1 text-1 bold color-red-default mt-10 pointer underline" @click="$windowOpen('https://mp.weixin.qq.com/s/e7efFmXXRPMzZmsJwKx9Ag')">点击了解峰会学生实习生</p>
        <h2 class="h2 color-gray-1 mt-30">HSYLC大学生志愿者</h2>
        <p class="text1 color-gray-2 mt-20">
          如果你是往年峰会学生，并且已经升入大学学习，欢迎你作为HSYLC大学生志愿者回归峰会（截止2026年9月，大学生志愿者申请人必须完成大学一年级的学习），以“助教辅导员（TF）”、“活动管培生（EA）”、“全媒体助理（MA）”的不同身份深入体验峰会的幕后工作，短时间内快速掌握硬核职场技能，在高能跨国团队协作中激发自己的领导力。HSYLC
          2026 志愿者申请预计将在3月下旬开放。
        </p>
        <p class="text1 text-1 color-red-default underline mt-10 bold pointer" @click="$windowOpen('/join-us/volunteer')">
          点击了解峰会大学生志愿者项目详情
        </p>
        <div class="link-wrap">
          <router-link class="link-more next sybold" to="/instructions/dates">
            活动及申请时间
            <Arrow color="#17181A" width="14px" />
          </router-link>
          <!-- <router-link class="link-more next sybold" to="/instructions/tuition">
          费用及助学金
          <Arrow color="#17181A" width="14px" />
        </router-link> -->
        </div>
      </template>
    </div>
  </div>
</template>
<script>
// import Button from '../../../../components/form/Button';
import { Arrow } from '../../../../components/icons';
import ApplyBtn from '../../Components/ApplyBtn2';
import './index.less';
import '../index.less';
export default {
  name: 'Eligibility',
  components: {
    Arrow
  },
  mounted: function() {
    this.$mountedRob();
  },
  methods: {
    handleClickApply: function() {
      this.$router.push({
        name: 'student-apply'
      });
    }
  }
};
</script>
